export const OPERATOR_PATH = "/operator";
export const PROFILE_PATH = "/profile";
export const PUBLIC_ENTRY_PATH = "/";
export const PUBLIC_STUDIO_PATH = "/studio";
export const SITE_DESIGNER_PATH = "/operator/site-designer";

export function resolveApplicationRoute(pathname) {
  if (pathname === "/login") return "login";
  if (pathname === OPERATOR_PATH) return "operator";
  if (pathname === SITE_DESIGNER_PATH) return "site-designer";
  if (pathname === PROFILE_PATH) return "profile";
  if (pathname === "/" || pathname === PUBLIC_STUDIO_PATH) return "studio";
  return "not-found";
}

// "console": staff roles. "member": any other signed-in account (sees the studio map).
// "public": anonymous visitors (door and showcase).
export function resolveStudioEntryView(user) {
  if (!user) return "public";
  const consoleRoles = new Set(["PLATFORM_ADMIN", "ADMIN", "OWNER", "MANAGER", "RECEPTIONIST", "TRAINER"]);
  return user.roles?.some((role) => consoleRoles.has(String(role).toUpperCase())) ? "console" : "member";
}

export function resolveLoginReturnPath(search, origin = "http://localhost") {
  const requestedPath = new URLSearchParams(search).get("return");
  if (!requestedPath) return PUBLIC_ENTRY_PATH;

  try {
    const destination = new URL(requestedPath, origin);
    if (destination.origin !== origin) return PUBLIC_ENTRY_PATH;
    return `${destination.pathname}${destination.search}${destination.hash}`;
  } catch {
    return PUBLIC_ENTRY_PATH;
  }
}
